<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>ME Sky Express</strong> 

          </div>
         <!--  <div id="overlay" >
             <div class="loader"></div>
           </div> -->


         <div id="printable" >
            <div class="page-break" >
              <h4>BH Shipment Manifest To SKY EX</h4>
            <table style="border: 0.2px solid black; border-collapse: collapse;"  >
              <thead style="font-size:16px;">
                <tr>
                   <td style="border: 0.2px solid black; border-collapse: collapse;padding:5px;" colspan="1" rowspan="" headers="">
                    Date </td>
                    <td colspan="2"style="border: 0.2px solid black; border-collapse: collapse;padding:5px; " >{{dispatchdate}}</td>
                    <!-- &nbsp; : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{dispatchdate}} -->
                </tr>
                        <tr style="text-align:center;font-size:14px;">
                         <th style="border: 0.2px solid black; border-collapse: collapse;padding:5px;">SR.No</th>
                          <th style="border: 0.2px solid black; border-collapse: collapse;padding:5px;">Shipping ID &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                          <!-- <th>Country Code</th> -->
                          <th style="border: 0.2px solid black; border-collapse: collapse;padding:5px;">No.of Packages</th>
                          <!-- <th>Status</th> -->
                        
                           
                        </tr>
                      </thead>
                      <tbody>
                        
                        <tr style="text-align:center" v-for="(item,index) in batchnumberdata">
                          <td style="border: 0.2px solid black; border-collapse: collapse;padding:5px;">{{index + 1}}</td> 
                          <td style="border: 0.2px solid black; border-collapse: collapse;padding:5px;">{{item.shippingid}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                          <!-- <td>{{value.country}}</td> -->
                          <td style="border: 0.2px solid black; border-collapse: collapse;padding:5px;">1</td>
                           <!-- <td>{{value.status }}</td> -->
                        
                        </tr>
                        <br>
                      <tr>
                          <td style="font-size:16px;border: 0.2px solid black; border-collapse: collapse;padding:5px;" colspan="2" rowspan="" headers="">
                          Total Orders 
                        </td>
                        <!-- &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{totalbatchorder}} -->
                        <td colspan="1" style="font-size:16px;border: 0.2px solid black; border-collapse: collapse;padding:5px; text-align:center"  rowspan="" headers="">{{totalbatchorder}} </td>
                      </tr>
                      <tr>
                           <td style="font-size:16px;border: 0.2px solid black; border-collapse: collapse;padding:5px;" colspan="2" rowspan="" headers="">
                         Hand over by 
                        </td>
                        <td colspan="1" style="font-size:16px;border: 0.2px solid black; border-collapse: collapse;padding:5px;" rowspan="" headers=""></td>
                      </tr>
                        <tr >
                           <td  style="font-size:16px;border: 0.2px solid black; border-collapse: collapse;padding:5px;" colspan="2" rowspan="" headers="">
                         Received by
                        </td>
                         <td colspan="1" style="font-size:16px;border: 0.2px solid black; border-collapse: collapse;padding:5px;" rowspan="" headers=""></td>
                        </tr>
                          <tr style="font-size:16px;">
                           <td style="width:50%;border: 0.2px solid black; border-collapse: collapse;padding:5px;" colspan="2" rowspan="" headers="">
                        Signature :
                        </td>
                         <td style="width:50%;border: 0.2px solid black; border-collapse: collapse;padding:5px;" colspan="2" rowspan="" headers="">
                       Signature :
                        </td>
                        </tr>
                      </tbody>
            </table>
            </div>           
          </div>

        <div id="printableArea" >
            <div class="page-break" v-for="item in linehaularr" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.mezone_id}}
                          <barcode v-bind:value="item.mezone_id">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <!-- <span style ='font-size: 35px;  display: block;
  margin-bottom: 8px;'><b>{{item.master_awb}}</b></span> <br>
                          -->
                          <span style ='font-size: 30px;  display: block;
  margin-bottom: 8px;'><b>Zone Title:</b> &nbsp;{{item.mezone_name}}</span>
  <br>
                          <span style ='font-size: 30px; display: block;
  margin-bottom: 8px;' >Country Code:<b>{{item.country_code}}</b></span><br>
                        
                         
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
        <!-- code for model -->

     <!-- code for tab -->
          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
             
             

              <li class="nav-item">
                <a @click="activeTab = 1;actionfun('SkyEx_Pickup_Pending')"  class="nav-link" :class="{'active' : isActiveTab(1)}" >SkyEx Pickup Pending</a>
              </li>

              <li class="nav-item">
                <a @click="activeTab = 2;actionfun('SkyEx_Pickup_Pending_Zone_Assigned')"  class="nav-link " :class="{'active' : isActiveTab(2)}">SkyExpress Zone</a>
              </li>
               <!-- <li class="nav-item">
                <a @click="activeTab = 3;actionfun('SkyEx_Cpc_Zone_Assigned')"  class="nav-link " :class="{'active' : isActiveTab(3)}">SkyEx CPC Zone</a>
              </li> -->
              <li class="nav-item">
                <a @click="activeTab = 4;actionfun('SkyEx_Pickup_Done')"  class="nav-link" :class="{'active' : isActiveTab(4)}" >Out Scan</a>
              </li>
              <li class="nav-item">
                <a @click="activeTab = 5;actionfun('SkyEx_Delivered')"  class="nav-link" :class="{'active' : isActiveTab(5)}" >SkyEx UAE Hub Shipment</a>
              </li>
             
            </ul>
          </div>
           
          </b-col>
        </b-row>
        <br>
<!-- 
          <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1" v-if="selected_status=='SkyEx_Pickup_Done'">
         
        <b-row class="mb-1" >          

                <b-col md="6" class="my-1">
                    <b-col sm="12" >
                    <b-form-group label="Batchwise Out-Scan"  :label-cols="4" >

                    <v-select id="mySelect" v-model="batchlist"  :options="this.batchnumber"  name="batchlist" v-validate="'required'" :class="{ danger: errors.has('batchlist') }">
                      </v-select>

                    <span style="width: 270px;" v-show="errors.has('form-1.batchlist')" class="help text-danger">{{ errors.first('form-1.batchlist') }}</span>
                  </b-form-group>
                 </b-col>
                    </b-col> 
                     <b-col  md="4" class="my-1" >
                 <b-button   class="mr-4" type="submit" size="md" variant="primary">Search</b-button>
               </b-col>
              
              </b-row>
            </form> -->
   
        <!-- tab end -->

      <!-- Table Start  @click="downloadCSV"-->
      <br>
       <b-col sm="12" class="text-right" v-if="selected_status =='SkyEx_Pickup_Pending_Zone_Assigned'||selected_status =='SkyEx_Cpc_Zone_Assigned'">
              <br>
       
                <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ totalRowsitems }}</span></b> </p>
      </b-col>

        <b-col sm="12" v-if="selected_status=='SkyEx_Pickup_Pending_Zone_Assigned'||selected_status=='SkyEx_Cpc_Zone_Assigned'">
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"  :fields="fields1"  :current-page="currentPage"   :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
            <template slot="actions" slot-scope="row">
             
                  <input @change="setStickerHTMl($event,row.item)" type="radio" name="radAnswer" v-model="row.item.selected" class="shipmentscheckbox" id="stiker" :checked="checkData" >&nbsp;&nbsp;
                <b-button  id="printbutton" variant="primary" size="sm" value="print a div!" @click="barcodedata('printableArea',row.item)" style="background: #b0c4de !important;color: #000 !important;" >Print Zone </b-button>&nbsp;&nbsp;

                    <b-button v-if="selected_status=='SkyEx_Pickup_Pending_Zone_Assigned'" size="sm" @click="meproductdetails(row.item)" style="background: #b0c4de !important;color: #000 !important;">
                    View Products
                  </b-button>
                
                </template>

        
          </b-table>
        </b-col>
             <b-col sm="12" class="text-right" v-if="selected_status!='SkyEx_Pickup_Done'">
              <br>
       
                <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ totalRows }}</span></b> </p>
              </b-col> 
      

           <b-col sm="12" v-if="selected_status!='SkyEx_Pickup_Done'">
             <!-- <b-col sm="12"> -->
            <b-table  show-empty stacked="md" :busy="isBusy" :items="skyitems" :fields="dhlfields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :bordered="bordered" >
               
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
          </b-table>
        <!-- </b-col> -->
      </b-col>

      <!-- Table end -->
          <b-col md="6" class="my-1" v-if="selected_status!='SkyEx_Pickup_Done'">
            <b-col sm="12" v-if="totalRows>10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-col>

          <!-- code for Out for scan -->
          <b-col sm="12" class="text-right" v-if="selected_status=='SkyEx_Pickup_Done'">
          
             <!--  
              <div v-if="batchlist!=''">

                <b-button v-if="zonetotalRows>0" @click="outscanprintdata(printable)"  type="submit" style="margin-right: 10px;margin-bottom:5px;" v-b-tooltip.hover title="Print Shipment Manifest" variant="primary" size="md" >Print</b-button>
               
              </div> -->
                <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ zonetotalRows }}</span></b> </p>
              </b-col> 
      

           <b-col sm="12" v-if="selected_status=='SkyEx_Pickup_Done'">
             <!-- <b-col sm="12"> -->
            <b-table  show-empty stacked="md" :isBusy="zoneisbusy" :items="outscanitems" :fields="outscanfields"  :current-page="outscancurrentPage" :per-page="outscanperPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :bordered="bordered" >
               
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                 <template slot="actions" slot-scope="row">
                    <input @change="setprintStickerHTMl($event,row.item)" type="radio" name="radAnswer" v-model="row.item.selected" class="shipmentscheckbox" id="stiker" :checked="checkedData" >&nbsp;&nbsp;
                      <b-button v-if="return_msg !='Unsuccessful'" @click="outscanprintdata(printable,row.item)"  variant="primary" size="sm" value="print a div!" v-b-tooltip.hover title="Print Shipment Manifest" style="background: #b0c4de !important;color: #000 !important;" >Print Batch </b-button>&nbsp;&nbsp;
                      <span v-if="return_msg=='Unsuccessful'" style="color:red">No Shipment</span>
                 </template>
          </b-table>
        <!-- </b-col> -->
      </b-col>

      <!-- Table end -->
          <b-col md="6" class="my-1" v-if="selected_status=='SkyEx_Pickup_Done'">
            <b-col sm="12" v-if="zonetotalRows>10">
            <b-pagination
                v-model="outscancurrentPage"
                :total-rows="zonetotalRows"
                :per-page="outscanperPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-col>

          <b-modal size="xl" title="ME Zone Product Listing" v-model="meproductmodel">
          <!-- <template slot="modal-header" slot-scope="{ close }">
          <h5>Shipment Listing</h5>
          </template> -->
            <div id="overlay" >
             <div class="loader"></div>
           </div>

          <!-- v-if="this.totalRows >0"  -->
          <b-row >
             <b-col sm="6" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="productfilter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!productfilter" @click="productfilter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="text-right">
                <b-button v-if="this.total_row_product >0"  @click="downloadCSV" variant="primary" size="md" >Download </b-button> 
               <p > <b>Total Records :<span style="color:red;">{{total_row_product}}</span></b> </p>
              </b-col> 
          </b-row>
          <b-table show-empty stacked="md"  :items="meproductlisting" :busy="isBusyproduct"  :fields="productfields"  :current-page="currentPageproduct"   :per-page="perPageproduct"  :filter="productfilter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
           <!--  {{row.item.user_type == 0 ? 'Normal ' : row.item.user_type == 1 ? 'Privilage':'Warehouse'}} -->
         <!--     <template slot="modetransport" slot-scope="row">
             <b-button size="sm" @click="changemode(row.item)" class="mr-1">
                 <span>{{row.item.modeoftransport}}  </span>  
              </b-button>
            </template>
 -->
        
          </b-table>
      <!--     <div >
     <label  v-if="shipmentlist.length>0"><b>Shipping id</b></label>
     <label v-else><b>Shippingid's are not Available</b> </label>
   </div> -->
         <!--  <div class="row" >
    
      <div   v-for="(item, index) in shipmentlist">
       
          
        {{ item.shippingid}}<span >&nbsp;&nbsp;&nbsp;,</span>

      </div>
    </div>  perPageproduct
     -->
      <b-col md="12" class="my-1 " v-if="this.total_row_product > 10">
            <b-pagination
                v-model="currentPageproduct"
                :total-rows="total_row_product"
                :per-page="perPageproduct"
                class="my-0"
              ></b-pagination>
          </b-col>    


    
         <!--  <template slot="modal-footer" slot-scope="{ hide }"> -->
            <!-- Emulate built in modal footer ok and cancel button actions -->
          <!--   <b-button size="sm"  @click="closeeditAgentMaster()" >
              Cancel
            </b-button> -->
            <!-- Button with custom close trigger value -->
          <!-- </template> -->
      </b-modal> 

        </b-card>
   
      </b-col>
    </b-row> 
  </div>   


</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Router from 'vue-router' 
import VueBarcode from 'vue-barcode';

export default {
  data: function() {
    return {
      dropdownalert:'Please Select the Batch.No to See the Batchwise Listing',
      activeTab: 1,
      data1:[],
      isBusy: false,
      conformation:'',
        bordered: true,
        checkData:false,
        totalRowsitems:0,
        outscancurrentPage:1,
        outscanperPage:10,
        items:[],
        fields1: [
          { key: 'mezone_name', label: 'Zone Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'country_code', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass'  },
          { key: 'created_date', label: 'Created Date', sortable: true,tdClass: 'nameOfTheClass' },
          { key: 'actions', label: 'Actions',tdClass: 'nameOfTheClass'  },
         
        
       ], 
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
       skyitems:[],
       productfields:[],
       productitems:[],
       cdmstatus:'',
       cdmfeedstatus:'',
        editfeedbacktoggleInfo:false,
        approvetoggleInfo:false,
        rejecttoggleInfo:false,
         selectDateFrom:new Date(),
        selectDateTo:new Date(),
        outscanitems:[],
        zoneisbusy:false,
        outscanshipmentlist:[],
        outscanfields:[
         {key: 'hub_id',label:'Hub ID'},   
      {key: 'batchnumber', label: 'Batch Number'},
      // {key: 'shipmentstatus', label: 'Shipment Status'},
        // {key: 'deliverystatus', label: 'Delivery Status'}, 
     
       {key: 'dispatch_date', label: 'Dispatch Date'},
        {key: 'actions', label: 'Action',tdClass: 'nameOfTheClass'},
        ],
        dhlfields:[],
       deliveryagentid:'',
       agentid: 0,
       feedbackmsg:'',
       Feedbacktext:'',
       Rejecttext:'',
       requestid:0,
       walletamount:0,
       selected:'',
       agentmaster:[],
       batchnumberdata:[],
       totalbatchorder:0,
       batchnumber:'',
       dispatchdate:'',
       masterawbdataarr:[],
       printstickerdata:[],
       printfields:[
        {key: 'srno',label:'Sr.No'},   
      {key: 'shippingid', label: 'Shipping Id'}, 
      {key: 'package', label: 'No of Package'}
       ],
      name: 'me_skyexpress',
      selected_status:'SkyEx_Pickup_Pending',
      imgpath:'',
      createdby:'',
      mezoneid:'',
     mezoneidcsv:'',
      linehaularr:[],
      batchlist:'',
      return_msg:'',
       meproductmodel:false,
        total_row_product:0,
        currentPageproduct:1,
        perPageproduct:10,
        meproductlisting:[],
        isBusyproduct:false,
        productfilter:null,
         productfields:[
          { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productid', label: 'Product ID', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productname', label: 'Product Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'hsncode', label: 'HSN Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productquantity', label: 'Product Quantity', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productvalue', label: 'Product Value', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'countrycode', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'countryoforigin', label: 'Country Of Origin', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
            { key: 'modeoftransport', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
       ],
    };
  },
  components: {
    'barcode': VueBarcode
  },
 created: function() {
    this.isActiveTab(1);
    // this.displaybatchwiselisting();
    this.actionfun(this.selected_status);
    // this.getbatchwiselist();
  },
 
  methods: {
    //     validateForm(scope) {
    //   this.$validator.validateAll(scope).then((result) => {
    //     if (result) {
    //       // this.toggleInfo = !this.toggleInfo
    //       
    //     }
    //   })
    // },
    isActiveTab(id)

    {
      // alert(id);
       return this.activeTab === id
    },
       // Main Function
    actionfun:function(status){
      // alert(status);
     
       var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      
      this.selected_status=status;
       this.isBusy = true;
       const obj = {
       hub_id: 36058,
      status:status,
       countrycode:'UAE',
      };
     
      
      if(status=="SkyEx_Pickup_Pending"){
        this.skyitems=[];
        this.currentPage=1;
        this.totalRows=0;
        this.dhlfields=[
      {key: 'hub_id',label:'Hub ID'},   
      {key: 'shippingid', label: 'Shipping Id'},
        {key: 'shipmentstatus', label: 'Shipment Status'},
        {key: 'deliverystatus', label: 'Delivery Status'}, 
      {key: 'modeoftransport', label: 'Mode Of Transport'},
      {key: 'date', label: 'Created Date'},

        ]
       
      }
       if(status=="SkyEx_Pickup_Pending_Zone_Assigned"){
        this.skyitems=[];
        this.currentPage=1;
        this.totalRows=0;
        this.dhlfields=[
      {key: 'hub_id',label:'Hub ID'},   
      {key: 'shippingid', label: 'Shipping Id'}, 
       {key: 'shipmentstatus', label: 'Shipment Status'},
        {key: 'deliverystatus', label: 'Delivery Status'},
      {key: 'modeoftransport', label: 'Mode Of Transport'},
       {key: 'countrycode', label: 'Country'},
        {key: 'date', label: 'Updated Date'},
        
        ]
      }
        if(status=="SkyEx_Cpc_Zone_Assigned"){
        this.skyitems=[];
        this.totalRows=0;
        this.currentPage=1;
        this.dhlfields=[
      {key: 'hub_id',label:'Hub ID'},   
      {key: 'shippingid', label: 'Shipping Id'}, 
       {key: 'shipmentstatus', label: 'Shipment Status'},
        {key: 'deliverystatus', label: 'Delivery Status'},
      {key: 'modeoftransport', label: 'Mode Of Transport'},
       {key: 'countrycode', label: 'Country'},
        {key: 'date', label: 'Updated Date'},
        
        ]
      }
    if(this.selected_status=="SkyEx_Pickup_Done"){
        this.getbatchwiselist();
      }
             if(status=="SkyEx_Delivered"){
          this.skyitems=[];
          this.currentPage=1;
        this.totalRows=0;
         this.dhlfields=[
      {key: 'hub_id',label:'Hub ID'},   
      {key: 'shippingid', label: 'Shipping Id'}, 
       {key: 'shipmentstatus', label: 'Shipment Status'},
        {key: 'deliverystatus', label: 'Delivery Status'},
      {key: 'modeoftransport', label: 'Mode Of Transport'},
       {key: 'countrycode', label: 'Country'},
       {key: 'date', label: 'Updated Date'},
      
        ]
      }
      if(status!="SkyEx_Pickup_Done"){
      this.$http
        .post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getskyexpressshipmentlisting`,obj
        )
        .then(result => {
            if(this.selected_status=="SkyEx_Cpc_Zone_Assigned"){
               this.checkData=false;
               this.items=[];
            this.displaycpczone();
          }
          if(this.selected_status=="SkyEx_Pickup_Pending_Zone_Assigned"){
            this.checkData=false;
            this.items=[]
            this.displaydata();
          }
      
          if (result.body.returnmsg == 'Successful') {
            // alert(this.batchnumber)
            this.isBusy = !this.isBusy
               
            this.skyitems  = result.body.returnvalue;
            // console.log("skyitems",this.skyitems);
            this.totalRows = result.body.returnvalue.length;
          
            
          } else {
            this.isBusy = !this.isBusy
            this.skyitems  = [];
            this.totalRows=0;
            
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
      }
    },
    displaydata: function () {
      // alert("getlinehaulpalletlisting");
    // this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

       const obj = {
        // hub_id:`${userInfo.pickuplocationmasterid}`,
        hub_id: 36058,
        submit_via:'SkyExpress',
        countrycode:'UAE',
      };
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmezonelist`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.items  = result.body.returnvalue;
             // console.log(this.items);
             // this.items=[];
             // this.totalRows =0;
             this.totalRowsitems = result.body.returnvalue.length;
             // this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRowsitems=0;
               // this.isBusy = !this.isBusy;
          }
          // this.meproductdetails();
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    displaycpczone:function(){
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

       const obj = {
        // hub_id:`${userInfo.pickuplocationmasterid}`,
        hub_id: 36058,
        submit_via:'SkyExpress_ClientPickCancel',
        countrycode:'UAE',
      };
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmezonelist`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.items  = result.body.returnvalue;
             // console.log(this.items);
             // this.items=[];
             // this.totalRows =0;
             this.totalRowsitems = result.body.returnvalue.length;
             // this.isBusy = !this.isBusy;
          } else {
            this.items=result.body.returnvalue;
            this.totalRowsitems=0;
               // this.isBusy = !this.isBusy;
          }
          // this.meproductdetails();
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    
    // Function For Product Listing 13/09
      downloadCSV: function() {
  // alert(this.mezoneidcsv);
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
      // alert()
          const csvObj = {
         mezone_id: this.mezoneidcsv,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
        hub_id: 36058,
       sysusermasterid:`${userInfo.sysusermasterid}`,  
       submit_via:'SkyExpress',
          };
          // console.log("csvobj",csvObj);
          // return false;
this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getproductdetailsagainstmezonecsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         alert("Please Check Your Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Your Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       }); 
       }
       else
       {
        alert("Can not Download");
          // this.$fire({
          //         text:"Can not Download",
          //         type: "error",
          //         timer: 30000
          //       }); 
       }
        
        });
        
    },


          meproductdetails: function(value) {
            // alert("innn");
            // console.log(value);
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(value.pallet_id);
      //alert(" i m in info model");
      this.isBusyproduct=true;
      this.mezoneid=value.mezone_id;
      this.mezoneidcsv=value.mezone_id;
      if(this.selected_status=="SkyEx_Pickup_Pending_Zone_Assigned"){
      var productObj = {
         mezone_id:this.mezoneid,
            // mezone_id:value.mezone_id,
            // mezone_name:value.mezone_name,
         // country_code:value.country_code,
         // created_date:value.created_date,
         submit_via:'SkyExpress',
        // hub_id:`${userInfo.pickuplocationmasterid}`,
        hub_id: 36058,
        };  
      // console.log('Params',productObj);
      // return false;
       }else if(this.selected_status=="SkyEx_Cpc_Zone_Assigned"){
         var productObj = {
         mezone_id:this.mezoneid,
            // mezone_id:value.mezone_id,
            // mezone_name:value.mezone_name,
         // country_code:value.country_code,
         // created_date:value.created_date,
         submit_via:'SkyExpress_ClientPickCancel',
        // hub_id:`${userInfo.pickuplocationmasterid}`,
        hub_id: 36058,
        };  

       }
       // this.meproductmodel = true;
// getshipmentlistfromlinehaulpallet

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getproductdetailsagainstmezone`,productObj)
        .then((result) => {
          // console.log("mezone",result);
          if (result.body.returnmsg === 'Successful') {
             
          
           
               // this.shipmentlist  = result.body.returnvalue
           // console.log(this.shipmentlist);
                
                this.meproductlisting=result.body.returnval;
                // console.log("IIIIIIIddddddddd",this.meproductlisting);
                this.total_row_product=result.body.returnval.length;
                  // console.log("length",this.total_row_product);
                   this.isBusyproduct = !this.isBusyproduct;
               this.meproductmodel =!  this.meproductmodel;
                
          } 
          else {
             this.isBusyproduct = !this.isBusyproduct;
          this.meproductlisting=[];
            this.total_row_product=0;
          this.meproductmodel =!  this.meproductmodel;
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    
      
      
    },
    setprintStickerHTMl:function(event,value){

       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.batchnumber=value.batchnumber;
      this.dispatchdate=value.dispatch_date;
      this.checkData=true;
      //agentmaster
      // alert(value.batchnumber);
      const batchwiselisting = {
        // deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        // isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
         batchnumber:this.batchnumber,
         countrycode:'UAE',
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getbatchnumberoutscanshipmentlist`, batchwiselisting)
        .then((result) => {
          this.return_msg=result.body.returnmsg;
          console.log("tttttt",this.return_msg);
            if (result.body.returnmsg === 'Successful') {
          this.batchnumberdata = result.body.returnvalue;
          this.totalbatchorder=result.body.returnvalue.length;
          console.log("totalorder",this.totalbatchorder);
        }else{
           this.batchnumberdata=[];
           this.totalbatchorder=0;
        }
       
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    // setprintStickerHTMl:function(){

    // },

     getbatchwiselist:function(){
      // alert('innnn');
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       // this.showValues=true;
      this.zoneisbusy = true;
       // var deliveryagentid=(this.selectedagent!=null)? this.selectedagent:"";
       // document.getElementById("batchwise").style.display="none"
        const obj = {
       // hub_id:`${userInfo.pickuplocationmasterid}`,
       hub_id: 36058,
       status:this.selected_status,
       countrycode:'UAE',
      
       
      };
    
    this.$http
        .post(
          `${
            CONSTANTS.MIGRATION_API_URL
          }/getbatchnumberlisting`,obj
        )
        .then(result => {
          if (result.body.returnmsg == 'Successful') {
            this.zoneisbusy = !this.zoneisbusy
               
            this.outscanitems  = result.body.returnvalue;
            // console.log("outscanitems",this.outscanitems);
            this.zonetotalRows = result.body.returnvalue.length;
            // this.printbatchwiselist();
            
          } else {
            this.zoneisbusy = !this.zoneisbusy
            this.outscanitems  = [];
            this.zonetotalRows=0;
            // this.dropdownalert='';
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
      // }else{
      // }

    },

    // printbatchwiselist:function(){
    //   // alert('innnn');
    //    var userdata = localStorage.getItem('userData')
    //   var userInfo = JSON.parse(userdata)
    //    // this.showValues=true;
    //   // this.isBusy = true;
    //    // var deliveryagentid=(this.selectedagent!=null)? this.selectedagent:"";

    //     const printobj = {
    //    hub_id:`${userInfo.pickuplocationmasterid}`,
    //   batchnumber:this.batchlist.key,
       
    //   };
    //   console.log("hiiiiii",printobj);
    //   // return false;
    //  // if(status=="SkyEx_Pickup_Done"){
    //  //    this.skyitems=[];
    //  //    this.totalRows=0;
    //  //         this.dhlfields=[
    //  //  {key: 'hub_id',label:'Hub ID'},   
    //  //  {key: 'shippingid', label: 'Shipping Id'}, 
    //  //  {key: 'modeoftransport', label: 'Mode Of Transport'},
    //  //   {key: 'countrycode', label: 'Country'},
    //  //    ] 
    //  //  }

    //    // if(this.selectedagent!='' &&  this.selectedagent!=null){

    // this.$http
    //     .post(
    //       `${
    //         CONSTANTS.MIGRATION_API_URL
    //       }/getbatchnumberoutscanshipmentlist`,printobj
    //     )
    //     .then(result => {
    //       if (result.body.returnmsg == 'Successful') {
    //         // this.isBusy = !this.isBusy
               
    //         this.outscanshipmentlist  = result.body.returnvalue;
    //         console.log("outscanshipmentlist",this.outscanshipmentlist);
    //         // this.zonetotalRows = result.body.returnvalue.length
            
    //       } else {
    //         // this.isBusy = !this.isBusy
    //         this.outscanshipmentlist  = [];
    //         // this.zonetotalRows=0;
            
    //       }
    //     })
    //     .catch(ex => {
    //       console.log("error", ex);
    //     });
    //   // }else{
    //   // }

    // },

     setStickerHTMl(e,value){
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
          this.selectedzoneid=value.mezone_id;
          // alert(this.selectedzoneid);
             this.linehaularr=[];
         this.checkedData=true;
    
 const obj = {

         mezone_id:value.mezone_id,
         mezone_name:value.mezone_name,
         country_code:value.country_code,
         created_date:value.created_date,
         // created_by:value.created_by
 
      }

              this.linehaularr.push(obj);
    },
  barcodedata(printableArea,value){
    // alert(value.mezone_id)
if(this.checkedData==true&&this.selectedzoneid==value.mezone_id)
{

     var printContents = document.getElementById("printableArea").innerHTML;
    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding: 10px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');

       docprint.document.write('</head><body onLoad="self.print()"><center>');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();
}
else
{
  alert("Please Select Radion Button");
   this.checkedData=false;
   this.selectedzoneid=0;
}
},
    

        outscanprintdata(printable,value){
          // alert(value.batchnumber);
 if(this.checkData==true&&this.batchnumber==value.batchnumber)
{
     var printContents = document.getElementById("printable").innerHTML;

    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:16px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 10px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding: 5px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:10px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');

       docprint.document.write('</head><body onLoad="self.print()"><center>');



       // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');


        // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();
           }
else
{
  alert("Please Select Radion Button");
   
}
      // localStorage.removeItem("reloaded");
     // location.reloaded();
       //self.close();

// }
// else
// {
  // alert("Please Select Radion Button");
   // this.$fire({
   //                text:"Please Select Radion Button",
   //                type: "warning",
   //                timer: 30000
   //              }); 
// }
    },
    
    
    

  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }




  

};
</script>
<style>
  .approved_block{
    word-wrap: break-word;
    width: 70px !important;
    /*background-color: red*/
  }
  .cdm_table{
    width: 100px;
  }
</style>
